import { render, staticRenderFns } from "./createOrVisitSuggestionsList.vue.html?vue&type=template&id=577631f6&"
import script from "./createOrVisitSuggestionsList.ts?vue&type=script&lang=ts&"
export * from "./createOrVisitSuggestionsList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports